import { Button } from "flowbite-react"
import React, { ReactNode, useEffect, useState } from "react"

import { IDomain } from "@mono/essentials/types/UserTypes"

import { ButtonWidgetType } from "../ButtonWidget"
import SelectProductModal from "../SelectproductModal"

interface ButtonDataProps {
  data: ButtonWidgetType
  isIntegratedPage?: boolean
  domainDetails?: IDomain
  nextStep?: string
  hideCustomerDetails?: boolean
}

const ButtonPreview = ({
  data,
  isIntegratedPage,
  domainDetails,
  nextStep,
  hideCustomerDetails = false,
}: ButtonDataProps) => {
  const [show, setShow] = useState<boolean>(false)
  const linkButton = data.button_type === "link_button"
  const buttonType = linkButton ? "ghost" : "primary"

  const handleButtonClick = () => {
    if (window !== window.parent) {
      const json = {
        msg: "openFullScreenPopup",
        url: `${document.URL}&nextStep=true`,
        isFrom: "smartRez",
      }
      window.parent.postMessage(JSON.stringify(json), "*")
    } else {
      setShow((prev) => !prev)
    }
  }

  useEffect(() => {
    if (nextStep === "true") {
      setShow(true)
    }
  }, [nextStep])

  const productDetails = {
    category_id:
      data.link_to === "products_view"
        ? data.category_product_view
        : data.link_to === "specific_category"
          ? data?.category
          : "",
    show_select_product: !!(
      data.link_to === "products_view" || data.link_to === "specific_category"
    ),
    product_description_view: data.show_product_detail_page,
    show_specific_product_detail: data.link_to === "specific_product",
    product_id: data.link_to === "specific_product" ? data.product : "",
  }

  const handleModalClose = (isCancel) => {
    if (window !== window.parent && isCancel) {
      const json = {
        msg: "hideFullScreenPopUp",
        isFrom: "smartRez",
      }
      window.parent.postMessage(JSON.stringify(json), "*")
    }
  }

  let buttonStyle = `[&>span]:!font-regular`

  if (data?.button_text_style === "bold") {
    buttonStyle = `[&>span]:!font-bold`
  } else if (data?.button_text_style === "medium") {
    buttonStyle = `[&>span]:!font-medium`
  }

  return (
    <>
      {!nextStep && (
        <Button
          color={buttonType}
          style={{
            backgroundColor: linkButton ? "white" : data?.theme_brand_color,
            color: data?.button_tab_text_color,
          }}
          size={data.button_size}
          className={buttonStyle}
          onClick={handleButtonClick}
        >
          Book Now
        </Button>
      )}
      <SelectProductModal
        show={show}
        setShow={setShow}
        productDetails={productDetails}
        isIntegratedPage={isIntegratedPage}
        domainDetails={domainDetails}
        handleClose={handleModalClose}
        nextStep={nextStep}
        hideCustomerDetails={hideCustomerDetails}
      />
    </>
  )
}

export default ButtonPreview
